/**
 * Responsible for applying an error to a form field.
 * @module elements/fields/validator
 */
import $ from 'jquery';
import registerJQueryPlugin from '../../lib/register-jquery-plugin';

const DEFAULT_INVALIDATE_OPTIONS = {
  formFieldSelectors: 'input,textarea,select',
  message: 'Received an error',
};

/**
 * Responsible for setting an element as being invalid.
 * @example
 * $('.some-selector').invalidate({
 *   message: 'oh noes??!?! what happened??!?!?1?!',
 * });
 *
 * @param {HTMLElement} el - An element, presumably a form element
 * @param {Object} options - Configurable options
 */
export default function invalidate(el, options = {}) {
  const $el = $(el);
  const {
    formFieldSelectors,
    message,
  } = $.extend({}, DEFAULT_INVALIDATE_OPTIONS, options);

  if ($el.is(formFieldSelectors)) {
    el.setCustomValidity(message);
    return;
  }

  const $formField = $el.find(formFieldSelectors);
  if ($formField.length) {
    // Grab the first one in the case where there could be more than one, i.e.
    // checkboxes or radios.
    // TODO: See if this needs to be more comprehensive
    $formField[0].setCustomValidity(message);
  }
}

registerJQueryPlugin('invalidate', invalidate, { cache: false });



// WEBPACK FOOTER //
// ./styleguide/src/assets/elements/fields/invalidate.js